import { render, staticRenderFns } from "./dataflow.vue?vue&type=template&id=52ffe4eb&scoped=true&"
import script from "./dataflow.vue?vue&type=script&lang=js&"
export * from "./dataflow.vue?vue&type=script&lang=js&"
import style0 from "./dataflow.vue?vue&type=style&index=0&id=52ffe4eb&lang=scss&scoped=true&"
import style1 from "./dataflow.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52ffe4eb",
  null
  
)

export default component.exports